import { BaseStore } from 'ynf-core-engine/stores';
import { extendObservable, reaction } from 'mobx'

class ReferStore extends BaseStore {
  [x: string]: any
  constructor (props: any) {
    super()
    this.rootSore = props
    this.makeObservable()
    this.initReaction()
  }

  makeObservable () {
    const { refCode, serviceCode, path, domainKey, busiObj, billNo, dataSourceAlias, conTextQuery, datasource } = this.rootSore.referInputProps
    const pageInfo = this.rootSore.pagingStore?.pageInfo
    extendObservable(this, {
      // requestData: computed, // 不能用计算属性--属性要整体和-值的可能不变 不触发响应
      requestData: {
        billnum: billNo,
        condition: undefined,
        treeCondition: undefined,
        likeValue: undefined, // 搜索值
        dataType: undefined,
        // isMasterOrg,
        // masterOrgValue,
        page: pageInfo || { pageIndex: 1, pageSize: 10, totalCount: 0 },
        path,
        datasource,
        refCode,
      },
      smartSearchData: {},
      params: {
        ...conTextQuery,
        busiObj,
        datasource: dataSourceAlias,
        domainKey: domainKey,
        feV: 6,
        refCode,
        serviceCode
      },
      collectType: 1, // 收藏状态
      searchFlag: {}, // 搜索标记
      exactQuery: false, // 是否精准搜索
      stopShow: undefined, // 显示停用
      referValue: [], // 参照选择的值
      btnAddVisible: true, // 参照新增
      btnEditVisible: true, // 参照编辑
      modalVisible: false, // 弹窗显示
    })
  }

  initReaction () {
    // const { rowStore } = this.rootSore.referInputProps
    // reaction(() => this.modalVisible, (value: any) => {
    //   rowStore && (rowStore.bCanModify = value)
    // })
  }

  getValue (itemName: string) {
    const arr: string[] = itemName.split('.')
    let res = this
    while (arr.length) {
      res = res[arr.shift() as keyof typeof res]
    }
    return res
  }

  setValue (itemName: string, value: any) {
    const arr: string[] = itemName.split('.')
    let res = this
    for (let i = 0; i < arr.length; i++) {
      const ele = arr[i]
      if (arr.length === 1) {
        this[ele] = value
      } else if (arr.length - 1 === i) {
        res[ele] = value;
        this[arr[arr.length - 1]] = { ...this[arr[arr.length - 1]] } // 这个是让宿主对象响应
      } else {
        res = res[arr[i]];
      }
    }
  }
}

export default ReferStore
